import React from 'react'
import styled from 'styled-components'

import { ROUTES } from '../../../../constants/links'

import { Link, useLocation } from 'react-router-dom'
import Dropdown from './Dropdown'

const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 12px;
  gap: 4px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
  `};
`

const RouteLink = styled(Link)<{ active: string }>`
  display: flex;
  align-items: center;
  padding: 8px 8px;
  font-size: 16px;
  color: ${({ theme }) => theme.text2};

  cursor: pointer;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.text1};
  }

  color: ${(props) => (props.active === 'true' ? '#4AFC38' : '')};
`

export default function MenuV2Desktop() {
  const location = useLocation()
  const { pathname } = location

  return (
    <MenuContainer>
      {ROUTES.map((route) => {
        return (
          <React.Fragment key={route.name}>
            {'childrens' in route ? (
              <>
                <Dropdown buttonLabel={route.name}>
                  {route.childrens.map((child, childIndex) => (
                    <RouteLink
                      key={childIndex}
                      to={child.route}
                      active={(
                        child.routeMatches.findIndex((route) => new RegExp(route).test(pathname)) !== -1
                      ).toString()}
                    >
                      {child.name}
                    </RouteLink>
                  ))}
                </Dropdown>
              </>
            ) : (
              <RouteLink
                to={route.route}
                active={(route.routeMatches.findIndex((routeM) => new RegExp(routeM).test(pathname)) !== -1).toString()}
              >
                {route.name}
              </RouteLink>
            )}
          </React.Fragment>
        )
      })}
    </MenuContainer>
  )
}
